import { AppLinkComponent } from "@sellernote/shared/src/api/dto/entities/common/common";
import { formatDate } from "@sellernote/shared/src/utils/date";
import { getArticleCategoryString } from "@sellernote/features/src/common/utils/support";

import BoardListItem from "../BoardListItem";
import BoardVideoItem from "../BoardVideoItem";
import Styled from "./index.styles";

export default function BoardList({
  type = "default",
  listData,
  boardItemHref,
  LinkComponent,
  className,
}: {
  type?: "default" | "search" | "video";
  listData: any[];
  boardItemHref: string;
  LinkComponent: AppLinkComponent;
  className?: string;
}) {
  return (
    <Styled.container
      className={`${className ? className : ""} board-list`}
      type={type}
    >
      {type === "default" &&
        listData.map(({ title, createdAt, groupId }) => (
          <BoardListItem
            title={title}
            date={formatDate({
              date: createdAt,
              type: "YY_MM_DD",
            })}
            writer="ShipDa"
            href={`${boardItemHref}/${groupId}`}
            key={`board-item-${groupId}`}
            LinkComponent={LinkComponent}
          />
        ))}

      {type === "search" &&
        listData.map(({ title, createdAt, groupId }) => (
          <BoardListItem
            title={title}
            date={formatDate({
              date: createdAt,
              type: "YY_MM_DD",
            })}
            writer="ShipDa"
            href={`${boardItemHref}/${groupId}`}
            key={`board-item-${groupId}`}
            LinkComponent={LinkComponent}
          />
        ))}

      {type === "video" &&
        listData.map(({ title, category, videoUrl, groupId }) => (
          <BoardVideoItem
            title={title}
            category={getArticleCategoryString(category)}
            videoUrl={videoUrl}
            href={`${boardItemHref}/${groupId}`}
            key={`board-item-${groupId}`}
          />
        ))}
    </Styled.container>
  );
}
